import React, { useRef, useCallback, useState } from 'react';
import { Row, Col, Tabs, message, Tooltip } from 'antd';
import { DownloadOutlined, ReloadOutlined } from '@ant-design/icons';
// O resolver legado do ESLint não interpreta o campo `exports` do react-to-print v3.
// eslint-disable-next-line import/no-unresolved
import { useReactToPrint } from 'react-to-print';
import { useHistory } from 'react-router-dom';

import { Motorista } from './Motorista';
import { Veiculo } from './Veiculo';
import { TemplateToPrint } from '../../TemplateToPrint';
import { useAuth } from '../../../../../hooks/auth';

import {
  postReanalisarSolicitacao,
  putAtualizarConsultas,
} from '../../../../../services';

import * as S from '../styles';

const { TabPane } = Tabs;

export function DadosMotorista({ data, loading = false }) {
  const history = useHistory();
  const { temPermissao } = useAuth();
  const [atualizandoConsultas, setAtualizandoConsultas] = useState(false);
  const pageStyle = `
  @media all {
    .page-break {
      display: none;
    }
  }

  @media print {
    html, body {
      background-color: #F1F4F5 !important;
      padding: 8px 18px !important;
      height: initial !important;
      overflow: initial !important;
      -webkit-print-color-adjust: exact;
    }
    .page-break {
      display: block;
      age-break-before: always;
    }
  }

  @page {
    size: 297mm 420mm;
    // size: landscape;
    margin: 0 !important;
    padding: 0 !important;
  }
`;
  const componentRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    pageStyle,
    documentTitle: () =>
      ['solicitacao', data?.idSolicitacao || 'detalhes'].join('-'),
  });

  const ordenarVeiculos = (a, b) =>
    a?.detalheTipoCadastro === 'Cavalo'
      ? -1
      : a?.detalheTipoCadastro > b?.detalheTipoCadastro
      ? 1
      : 0;

  const iniciarReanalise = useCallback(
    async idIntegracao => {
      try {
        const response = await postReanalisarSolicitacao(idIntegracao);
        if (response) {
          return history.push('/atendimento');
        }
      } catch (error) {
        message.error(
          error?.response?.data?.detail ||
            'Não foi possível iniciar o atentimento.'
        );
      }
    },
    [history]
  );

  const atualizarConsultas = useCallback(async idSolicitacao => {
    setAtualizandoConsultas(true);

    const response = await putAtualizarConsultas(idSolicitacao);

    if (response?.status >= 200 && response?.status < 300) {
      message.success('Consultas atualizadas com sucesso!');
    } else {
      message.error(
        response?.error?.response?.data?.detail ||
          'Não foi possível atualizar as consultas.'
      );
    }

    setAtualizandoConsultas(false);
  }, []);

  return (
    <Row justify="end">
      <Col span={24}>
        <Row justify="end" gutter={16}>
          {!loading && data && (
            <>
              {data?.idStatusSolicitacao === 1 && (
                <Col flex="none">
                  <Tooltip title="Atualizar consultas">
                    <S.BtnPrimaryColor
                      aria-label="Atualizar consultas"
                      icon={<ReloadOutlined />}
                      loading={atualizandoConsultas}
                      onClick={() => atualizarConsultas(data?.idSolicitacao)}
                    />
                  </Tooltip>
                </Col>
              )}
              {(data?.idStatusSolicitacao === 4 ||
                data?.idStatusSolicitacao === 7) &&
                temPermissao(['ReanaliseSolicitacao']) && (
                  <S.BtnPrimaryColor
                    onClick={() => iniciarReanalise(data?.idIntegracao)}
                  >
                    Reanalisar Solicitacao
                  </S.BtnPrimaryColor>
                )}
              <Col flex="none">
                <S.BtnPrimaryColor
                  icon={<DownloadOutlined />}
                  onClick={() => handlePrint()}
                >
                  Baixar PDF
                </S.BtnPrimaryColor>
                <Col style={{ display: 'none' }}>
                  <TemplateToPrint ref={componentRef} data={data} />
                </Col>
              </Col>
            </>
          )}
        </Row>
      </Col>
      <Col span={24} style={{ padding: '10px 0 0 0' }}>
        <S.SectionCard variant="outlined">
          <Col span={24} style={{ marginBottom: 26 }}>
            <S.TitleSectionMotorista>Cadastro</S.TitleSectionMotorista>
          </Col>
          <Tabs type="card">
            <TabPane
              key="1"
              tab="Motorista"
              defaultActiveKey="1"
              style={{
                padding: '0px 16px 16px 22px',
                borderRadius: '16px',
                background: '#fff',
                overflowY: 'auto',
                height: '100%',
              }}
            >
              <Motorista data={data?.motorista} loading={loading} />
            </TabPane>
            {data?.veiculos?.sort(ordenarVeiculos)?.map((item, index) => (
              <TabPane
                key={2 + index?.toString()}
                tab={item?.detalheTipoCadastro}
                style={{
                  padding: '0px 6px 16px 16px',
                  borderRadius: ' 16px',
                  background: '#fff',
                  overflowY: 'auto',
                  height: '100%',
                }}
              >
                <Veiculo veiculo={item} />
              </TabPane>
            ))}
          </Tabs>
        </S.SectionCard>
      </Col>
    </Row>
  );
}
